import React, { useEffect, useState } from 'react';
import { transferSubBatch } from '../../../actions/qtActions';
import { TextField, Button, Select, MenuItem, makeStyles } from '@material-ui/core';
import { showAlertSnackbar } from '../../../reducers/uiSlice';
import FullscreenLoading from '../../../components/Common/FullscreenLoading';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

const useStyles = makeStyles((theme) => ({
    root: {
        height: '60vh'
    },
    flexStyle: {
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        marginTop: 20,
        marginBottom: 20
    },
    title: {
        minWidth: 150
    },
    inputStyle: {
        width: 300
    },
    sectionStyle: {
        marginBottom: 40
    },
    sectionTitle: {
        fontWeight: 700,
        fontSize: 20
    }
}));

const CrossWarehouseTransfer = (props) => {
    const classes = useStyles();
    const { userCity, childBranchList } = props;
    const {t} = useTranslation('quickTransfer');
    const dispatch = useDispatch();

    const [subBatch, setSubBatch] = useState('');
    const [loading, setLoading] = useState(false);
    const [childBranch, setChildBranch] = useState(childBranchList[0].id);
    const [orderNum, setOrderNum] = useState('');
    const [childSubBatch, setChildSubBatch] = useState('');

    const handleReset = () => {
        setSubBatch('');
        setChildBranch(childBranchList[0].id);
        setOrderNum('');
        setChildSubBatch('');
    }

    function handleSubmit() {
        setLoading(true);
        let params = {
            sub_batch_no: subBatch,
            sub_warehouse_id: childBranch,
            parent_warehouse_id: userCity
        }
        dispatch(transferSubBatch(params))
        .then((res) => {
            setOrderNum(res.updated);
            setChildSubBatch(res.sub_batch_no);
            dispatch(showAlertSnackbar({message: t('transfer_success'), type: 'success'}))
        })
        .catch((err) => {
            dispatch(showAlertSnackbar({message: t('transfer_failure'), type: 'error'}))
        })
        .finally(() => {
            setLoading(false);
        })
    }

    return (
        <div>
            <div className={classes.sectionStyle}>
                <div className={classes.sectionTitle}>{t('transfer_info')}</div>
                <div className={classes.flexStyle}>
                    <div className={classes.title}>
                        {t('sub_batch_number')}
                    </div>
                    <TextField
                        className={classes.inputStyle}
                        variant="outlined"
                        value={subBatch}
                        onChange={ (e) => {setSubBatch(e.target.value)} }
                    />
                </div>
                <div className={classes.flexStyle}>
                    <div className={classes.title}>
                        {t('child_branch')}
                    </div>
                    <Select
                        className={classes.inputStyle}
                        variant="outlined"
                        value={childBranch}
                        onChange={(event)=>{setChildBranch(event.target.value)}}
                    >
                    {
                        childBranchList.map((branch) => (
                            <MenuItem value={branch.id}>{branch.name}</MenuItem>
                        ))
                    }
                    </Select>
                </div>
            </div>
            <div className={classes.sectionStyle}>
                <div className={classes.sectionTitle}>{t('transfer_res')}</div>
                <div className={classes.flexStyle}>
                    <div style={{marginRight: 10}}>
                        {t('order_num')}
                    </div>
                    <div>{orderNum}</div>
                </div>
                <div className={classes.flexStyle}>
                    <div className={classes.title}>
                        {t('created_sub_batch_number')}
                    </div>
                    <div>{childSubBatch}</div>
                </div>
            </div>
            <div style={{marginTop: 160, display: 'flex', justifyContent: 'space-between'}}> 
                <Button className={classes.resetStyle}
                    variant='contained' 
                    color='primary'
                    onClick={handleReset}
                >
                    {t('common:reset')}
                </Button>
                <Button className={classes.submitStyle}
                    variant='contained' 
                    color='secondary'
                    onClick={handleSubmit}
                    disabled={!subBatch || !childBranch}
                >
                    {t('common:submit')}
                </Button>
            </div>
            <FullscreenLoading open={loading}/>
        </div>
    );
}

export default CrossWarehouseTransfer;
